import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '@core/services/auth.service';
import {AppRoutes} from '@core/constant/app-routes.constant';

export const gestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const isAuthenticated = authService.isAuthenticated();
  if (isAuthenticated) {
    router.navigate([AppRoutes.home])
    return false;
  }

  return true;
};
